
import { Link } from "react-router-dom";
import { RefreshCw, Beaker } from "lucide-react";
import { Button } from "@/components/ui/button";
import ReagentCard from "@/components/ReagentCard";
import { Reagent } from "@/types/reagent.types";
import { dateToString } from "@/utils/dateUtils";

interface LatestReagentsListProps {
  reagents: Reagent[];
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

const LatestReagentsList = ({
  reagents,
  isLoading,
  error,
  refetch
}: LatestReagentsListProps) => {
  console.log("LatestReagentsList - reagents:", reagents?.length || 0, "isLoading:", isLoading);

  // Debug the actual reagent data for troubleshooting
  if (reagents && reagents.length > 0) {
    console.log("First reagent sample:", reagents[0]);
  }
  
  return <>
      {isLoading ? <div className="text-center py-12">
          <div className="flex flex-col items-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-reagent-blue mb-4"></div>
            <p className="text-gray-500">Loading reagents...</p>
          </div>
        </div> : error ? <div className="text-center py-12">
          <p className="text-red-500 mb-4">Failed to load reagents. Please try again.</p>
          <Button onClick={() => refetch()} variant="outline" className="flex items-center gap-2">
            <RefreshCw className="h-4 w-4" /> Try Again
          </Button>
        </div> : !reagents || reagents.length === 0 ? <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-100">
          <Beaker className="h-12 w-12 text-gray-400 mb-2 mx-auto" />
          <p className="text-gray-500 mb-2">Register to view available reagents.</p>
          <p className="text-gray-400 text-sm mb-4">Register now to add and view reagents.</p>
          <Button asChild>
            <Link to="/upload">Add a Reagent</Link>
          </Button>
        </div> : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {reagents.map(reagent => 
            <ReagentCard
              key={reagent.id}
              id={reagent.id}
              name={reagent.name}
              catalogNumber={reagent.catalogNumber || reagent.catalogue_number || ""}
              category={reagent.category || (reagent.categories && reagent.categories.name) || "Uncategorized"}
              description={reagent.description || ""}
              amount={
                reagent.amount !== null ? 
                  (reagent.amount_unit ? `${reagent.amount}${reagent.amount_unit}` : `${reagent.amount}`) 
                  : "Not specified"
              }
              location={(reagent.profiles && reagent.profiles.location) || `${reagent.city || ""}, ${reagent.country || ""}`.trim() || ""}
              imageUrl={reagent.imageUrl || reagent.image_url || undefined}
              userName={(reagent.profiles && reagent.profiles.username) || reagent.userName || ""}
              labName={(reagent.profiles && reagent.profiles.lab) || reagent.labName || ""}
              numberOfPackages={reagent.numberOfPackages || reagent.number_of_packages || undefined}
              expiryDate={dateToString(reagent.expiryDate || reagent.expiry_date || null)}
            />
          )}
        </div>}
    </>;
};

export default LatestReagentsList;
